import React from 'react';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/auth-member-search';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';

/*******************************/

// success view
export const authFlowCallerIdentificationPharmacySearchSuccess = ( props ) => {
    
    // dynamic class name
    const widgetClassName = classnames( 'ui-auth-flow-caller-identification-pharmacy-search', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchWidget
                className='ui-auth-flow-caller-identification-pharmacy-search__table-search'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                requestPayload= { props.requestPayload }
                persistTableData={ true }
            />

        </div>
    );
};

// set display name
authFlowCallerIdentificationPharmacySearchSuccess.displayName = 'authFlowCallerIdentificationPharmacySearchSuccess';

// set default props
authFlowCallerIdentificationPharmacySearchSuccess.defaultProps = {
    componentData: {},
};

// prop types
authFlowCallerIdentificationPharmacySearchSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowCallerIdentificationPharmacySearchPreloader = () => {
    return (
        <div className='ui-auth-flow-caller-identification-pharmacy-search-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
authFlowCallerIdentificationPharmacySearchPreloader.displayName = 'authFlowCallerIdentificationPharmacySearchPreloader';

// set default props
authFlowCallerIdentificationPharmacySearchPreloader.defaultProps = {};

// prop types
authFlowCallerIdentificationPharmacySearchPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowCallerIdentificationPharmacySearch as AuthFlowCallerIdentificationPharmacySearch } from 'ui/views/widgets/authFlowCallerIdentificationPharmacySearch';
 *
 * // render
 * <AuthFlowCallerIdentificationPharmacySearch propName='propValue'/>
 */
export const authFlowCallerIdentificationPharmacySearch = withNetworkState( authFlowCallerIdentificationPharmacySearchPreloader, withRouter( authFlowCallerIdentificationPharmacySearchSuccess ) );
